module.exports = "build/assets/topBlueBackground.ef7ea1e0.png";